import CountUp from "react-countup"
import { Link } from "react-router-dom"
import { ArrowRight } from "lucide-react"

import { DashboardState } from "../../../types"

interface Props {
  title: string
  stat: number
  index?: number
  icon: JSX.Element
  linkLabel: string
  linkHref: string
  state?: DashboardState
}

const INDEX_DEFAULT = 0

const DashboardStatCard: React.FC<Props> = ({
  title,
  index = INDEX_DEFAULT,
  stat,
  icon,
  linkLabel,
  linkHref,
  state
}) => {
  return (
    <Link
      to={linkHref}
      state={state}
      className="group flex-1 flex flex-col justify-between gap-5 rounded-lg bg-white border border-slate-200 p-5 xl:p-6 transition-all duration-200 hover:-translate-y-0.5 hover:border-primary-200 hover:shadow-[0_10px_28px_-14px_rgba(80,22,163,0.35)]"
    >
      <div className="flex items-start justify-between">
        <div className="min-w-0">
          <div className="text-xs font-medium uppercase tracking-wide text-slate-500">
            {title}
          </div>
          <div className="mt-1.5 text-3xl font-bold leading-none text-base-dark">
            <CountUp delay={index * 0.2} end={stat} duration={1} />
          </div>
        </div>
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary-50 text-primary-400 transition-colors group-hover:bg-primary-100">
          {icon}
        </div>
      </div>
      <div className="flex items-center gap-1 text-sm font-medium text-primary-400">
        <span>{linkLabel}</span>
        <ArrowRight
          size={15}
          className="transition-transform duration-200 group-hover:translate-x-0.5"
        />
      </div>
    </Link>
  )
}

export default DashboardStatCard
